import Vue from 'vue'
import Vuex from 'vuex'
import StationModule from './station'
import SecurityModule from './security'
import UserModule from './user'
import CommonModule from './common'
import StatisticsModule from './statistics'
import UsersModule from './users'
import StationsModule from './stations'
import ProductionModule from './production'

Vue.use(Vuex)

let store = new Vuex.Store({
  modules: {
    security: SecurityModule,
    station: StationModule,
    user: UserModule,
    users: UsersModule,
    common: CommonModule,
    statistics: StatisticsModule,
    stations: StationsModule,
    production: ProductionModule
  }
})

export default store
